export default {
  app: {
    railsEnv: 'production'
  },
  project: {
    copySourceBaseUrl: 'https://fundinno-stg6dw.com',
  }
}
